import React, { useCallback, useEffect, useState } from "react";
import './AccountSettings.css';
import API from '../API';
import { useAuth0 } from "@auth0/auth0-react";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import LogoutIcon from './images/icon-log-out.png';
import SettingsIcon from './images/icon-settings.png';
import WalletIcon from './images/icon-wallet.png';
import ConnectWalletButton from './ConnectWalletButton';
import NamiIcon from './images/nami_icon.png';
import EternlIcon from './images/eternl_icon.png';
import MetamaskIcon from './images/metamask_icon.png';
import NiftyGatewayIcon from './images/nifty_gateway_icon.png';

const AccountSettings = ({wallets, setWallets}) => {
    const { isAuthenticated, getAccessTokenSilently, user, logout, isLoading } = useAuth0();
    const [accessToken, setAccessToken] = useState(null);
    const [username, setUsername] = useState("");

    const reloadWallets = useCallback(async () => {
        if (isAuthenticated) {
            const accessToken = await getAccessTokenSilently({
                audience: process.env.REACT_APP_AUTH0_AUDIENCE,
                scope: "ffclient:play",
            });

            const response = await API.getWallets(accessToken);
            if (response.status !== 200) {
                console.log("Error getting wallets.");
                return;
            }
    
            const data = await response.json();
            setWallets(data.wallets);
        }
    }, [getAccessTokenSilently, isAuthenticated, setWallets]);

    useEffect(() => {
        async function getWallets() {
            if (isAuthenticated) {
                const accessToken = await getAccessTokenSilently({
                    audience: process.env.REACT_APP_AUTH0_AUDIENCE,
                    scope: "ffclient:play",
                });
                setAccessToken(accessToken);

                setUsername(user["https://futurefest.io/username"]);
                await reloadWallets();
            }
        };
        getWallets();
    }, [getAccessTokenSilently, isAuthenticated, user, reloadWallets]);

    if (isLoading) {
        return <div>Loading ...</div>;
    }

    return (
        <Tabs
            disableUpDownKeys={true}
            className="account-settings" 
            selectedTabClassName="account-settings__tab--selected"
            selectedTabPanelClassName="account-settings__tab-panel--selected">
            <TabList className="account-settings__tab-list">
                <Tab className="account-settings__tab"><img src={SettingsIcon} alt="Settings icon" />&nbsp;&nbsp;Account Settings</Tab>
                <Tab className="account-settings__tab"><img src={WalletIcon} alt="Wallet icon" />&nbsp;&nbsp;Connect Wallet</Tab>
                <button className="ff-button-logout bottom-center" onClick={() => logout({ returnTo: window.location.origin })}><img src={LogoutIcon} alt="Logout icon" />&nbsp;&nbsp;Logout</button>
            </TabList>

            <TabPanel className="account-settings__tab-panel">
                <h2 className="ff-header">Account Settings</h2>
                <br />
                <label htmlFor="input-username">Username:</label>&nbsp;
                <input id="input-username" className="username-input" value={username} onChange={(e) => setUsername(e.target.value)} type="text" disabled={true}></input>
                <br /><br/>
                <button className="ff-button" style={{display: "none"}} onClick={() => API.updateUsername(accessToken, {username: username})} disabled={true}>Update</button>
            </TabPanel>
            <TabPanel className="account-settings__tab-panel">
                <h2 className="ff-header">Connect Wallet</h2>
                { wallets.length === 0 && 
                    <div>No wallets connected.</div>
                }
                { wallets.map(wallet =>
                    <div key={wallet.address} className="wallet-address-line">
                        <span className="wallet-address">
                            { wallet.wallet === "nami" && <img className="wallet-icon" src={NamiIcon} alt="Nami wallet icon" /> }
                            { wallet.wallet === "eternl" && <img className="wallet-icon" src={EternlIcon} alt="Eternl wallet icon" /> }
                            { wallet.wallet === "metamask" && <img className="wallet-icon" src={MetamaskIcon} alt="Metamask wallet icon" /> }
                            { wallet.wallet === "nifty" && <img className="wallet-icon" src={NiftyGatewayIcon} alt="Nifty gateway wallet icon" /> }
                            { wallet.address }
                        </span>
                        <button className="wallet-delete-button" onClick={async () => {
                            const response = await API.deleteWallet(accessToken, wallet.address);
                            if (response.status !== 200) {
                                console.log("Error getting wallets.");
                                return;
                            }
                    
                            const data = await response.json();
                            setWallets(data.wallets);
                        }}>X</button>
                    </div>
                ) }
                <br />
                <ConnectWalletButton wallets={wallets} setWallets={setWallets} />
            </TabPanel>
        </Tabs>
    );
};

export default AccountSettings;
